/**
 * Contains code for the header navigation.
 *
 * @module LEANDER
 */
 var LEANDER = (function (module, $) {
	module.navigation = (function () {

		module.navigation = (function() {
			// Global vars
			/**
			 * @var navigationContainerClass Class of the overall container of the navigation
			 * @var searchToggleClass Class of the toggle that will reveal the search
			 * @var searchToggledClass Class to be attached when the search was toggled (i.e. visible)
			 * @var searchFocusClass Class of the element that requires focus to be set after the search was toggled.
			 * @var navigationToggleClass Class of the element that the user can activate to toggle the navigation
			 * @var navigationToggledClass Class to be toggled when the user has activated the element with navigationToggleClass
			 * @var navigationParentClass Class of elements inside the navigation that have child menu items
			 * @var navigationParentButtonClass Class of element next to each navigation parent that allows users to open/collapse the navigation on mobile.
			 * @var navigationParentActivatedClass Class attached to different items of this module to notify module that a navigation item was activated.
			 * @var navigationBackButtonClass Class of the element allowing users to navigate back inside the navigation.
			 * @var navigationContainerElements Container of all elements with navigationContainerClass
			 */
			let navigationContainerClass = 'page-header',
				searchToggleClass = 'search-form-reveal-container-button',
				searchToggledClass = 'search-form-toggled',
				searchFocusClass = 'js-search-form-focus-after-toggle',
				navigationToggleClass = 'site-navigation-mobile-toggle-button',
				navigationToggledClass = 'site-navigation-mobile-toggled',
				navigationWrapperClass = 'primary-navigation-wrapper',
				navigationParentClass = 'primary-navigation-item.has-children',
				navigationParentButtonClass = 'menu-main-mobile-parent-menu-item-button',
				navigationParentActivatedClass = 'js-menu-item-parent-activated',
				navigationBackButtonClass = 'menu-main-mobile-back-button',
				$navigationContainerElements = $( '.' + navigationContainerClass);

			/**
			 * This function iterates through all instances and sets them up.
			 * It iterates through all instances it can find, determines relevant child items
			 * and properties and calls a another routine which specifically deals with initialising
			 * a navigation.
			 */
			var setup = function() {
				var i,
					thisInstance,
					$thisInstanceElement,
					// Navigation toggler instance and jQuery element
					thisNavigationToggleInstance,
					$thisNavigationToggleElement,
					// Navigation item parent, instance and jQuery element
					thisNavigationMenuParentInstance,
					$thisNavigationMenuParentElement,
					// Desktop search toggler instance and jQuery element
					thisSearchToggleInstance,
					$thisSearchToggleElement,
					// Mobile menu "back" button
					thisNavigationBackButtonInstance,
					$thisNavigationBackButtonElement,
					// Button of a parent item to reveal child items
					thisNavigationMenuParentButtonInstance,
					$thisNavigationMenuParentButtonElement,
					// Desktop search element to be focussed instance and jQuery element
					thisSearchFocusInstance,
					$thisSearchFocusElement;

				for (i = 0; i < $navigationContainerElements.length; i++) {
					thisInstance = $navigationContainerElements[i];
					$thisInstanceElement = $(thisInstance);

					// Find element used to toggle the mobile navigation.
					thisNavigationToggleInstance = $thisInstanceElement.find(
						'.' + navigationToggleClass
					);
					$thisNavigationToggleElement = $(thisNavigationToggleInstance);

					// Find navigation items to mark as clicked on mobile. Ensure we only grab the anchors.
					thisNavigationMenuParentInstance = $thisInstanceElement.find(
						'.' + navigationParentClass
					);
					$thisNavigationMenuParentElement = $(thisNavigationMenuParentInstance);

					// Find navigation items to mark as clicked on mobile.
					thisNavigationMenuParentButtonInstance = $thisNavigationMenuParentElement.find(
						'.' + navigationParentButtonClass
					);
					$thisNavigationMenuParentButtonElement = $(
						thisNavigationMenuParentButtonInstance
					);

					// Find the navigation Back button for mobile users to go back to the initial view.
					thisNavigationBackButtonInstance = $thisInstanceElement.find(
						'.' + navigationBackButtonClass
					);
					$thisNavigationBackButtonElement = $(thisNavigationBackButtonInstance);

					// Find element to toggle the Desktop Search
					thisSearchToggleInstance = $thisInstanceElement.find(
						'.' + searchToggleClass
					);
					$thisSearchToggleElement = $(thisSearchToggleInstance);

					// Find element to be focussed when the Desktop search is toggled.
					thisSearchFocusInstance = $thisInstanceElement.find(
						'.' + searchFocusClass
					);
					$thisSearchFocusElement = $(thisSearchFocusInstance);

					setupNavigation(
						$thisInstanceElement,
						$thisNavigationToggleElement,
						$thisSearchToggleElement,
						$thisSearchFocusElement,
						$thisNavigationBackButtonElement,
						$thisNavigationMenuParentButtonElement
					);
				}
			};

			/**
			 * This function initialises a single navigation and attaches the
			 * corresponding listeners to different parts of the navigation.
			 * There are multiple functionalities handled here specifically:
			 *  - Navigation toggling. The user can activate the $navigationToggleElement to hide/show the navigation, usually on mobile.
			 *  - Search toggling. The user can activate the $searchToggleElement to hide/show the search. Usually on Desktop
			 *  - Search focussing. When the search is toggled (visible), ensure that the $searchFocusElement is focussed so it is readily available to the user.
			 *  - Navigation parent hiding. When $navigationMenuParentButtonElement is activated, we attach classes to the $navigationContainer and the $parentElement.
			 *       Through CSS we can then only show a back-button and the child items. When $navigationBackButtonElement is activated, we revert back to only showing the parents.
			 *       The code here only focusses on attaching classes, the actual hiding/showing of elements is achieved through CSS.
			 * @param {object} $navigationContainer
			 * @param {object} $navigationToggleElement
			 * @param {object} $searchToggleElement
			 * @param {object} $searchFocusElement
			 * @param {object} $navigationBackButtonElement
			 * @param {object} $navigationMenuParentButtonElement
			 */
			var setupNavigation = function(
				$navigationContainer,
				$navigationToggleElement,
				$searchToggleElement,
				$searchFocusElement,
				$navigationBackButtonElement,
				$navigationMenuParentButtonElement
			) {
				$navigationToggleElement.on( 'click', function() {
					toggleClass( $navigationContainer, navigationToggledClass);
				});

				$searchToggleElement.on( 'click', function() {
					toggleClass( $navigationContainer, searchToggledClass);
					if ( $navigationContainer.hasClass(searchToggledClass)) {
						$searchFocusElement.focus();
					}
				});

				// When the parent menu item's button is clicked, toggle a class on its parent to
				// let the child items know what the user wants to see them.
				// Also toggle a class on the nav container to ensure our mobile back button appears.
				$navigationMenuParentButtonElement.on( 'click', function() {
					let $parentElement = $(this).parent( '.' + navigationParentClass);

					toggleClass( $parentElement, navigationParentActivatedClass);
					toggleClass( $navigationContainer, navigationParentActivatedClass);
				});

				// When the back button is pressed, reset all reveal classes so
				// that all child items are hidden.
				// Also remove the class from the navigation container to ensure the back button disappears.
				$navigationBackButtonElement.on( 'click', function() {
					let $activatedElements = $navigationContainer.find(
						'.' + navigationParentActivatedClass
					);

					$activatedElements.removeClass(navigationParentActivatedClass);
					$navigationContainer.removeClass(navigationParentActivatedClass);
				});
			};

			/**
			 * Function to toggle the class on an element.
			 * @param {object} $container to toggle the class on
			 * @param {string} className to toggle
			 */
			var toggleClass = function( $container, className) {
				$container.toggleClass(className);
			};

			var anchorToBottom = function () {
				const $mainMenu = $('.' + navigationWrapperClass),
					offsetTop = $mainMenu.offset().top,
					height = $mainMenu.height(),
					bottomAnchorPoint = offsetTop + height + 'px';

				$('.sub-menu-container, .menu-main-mobile-parent-menu-item-button').css('top', bottomAnchorPoint);
			};

			/**
			 * This function triggers the navigation function
			 *
			 * @method init
			 * @private
			 */
			(function init() {
				if ( $navigationContainerElements.length > 0) {
					setup();
					$(document).ready(anchorToBottom);
					$(window).resize(anchorToBottom);
				}
			})();
		})();

	})();
	return module;
})(LEANDER || {}, jQuery);
